let eshopSwipers = {
    main: {
        slider: false,
        elem: $('.js-main-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            autoplay: {
                delay: 5000
            },
            delay: 10000,
            slidesPerView: 1,
            simulateTouch: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: false,
            speed: 700,
            pagination: {
                el: '.js-main-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-main-slider-next',
                prevEl: '.js-main-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            }
        }
    },
    wine: {
        slider: false,
        elem: $('.js-wine-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            slidesPerView: 1,
            simulateTouch: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: false,
            speed: 400,
            pagination: {
                el: '.js-wine-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-wine-slider-next',
                prevEl: '.js-wine-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            }
        }
    },
    testimonials: {
        slider: false,
        elem: $('.js-testimonials-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 1,
            simulateTouch: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoHeight: false,
            speed: 400,
            pagination: {
                el: '.js-testimonials-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-testimonials-slider-next',
                prevEl: '.js-testimonials-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            }
        }
    },
    popular: {
        slider: false,
        elem: $('.js-popular-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 16,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-popular-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-popular-slider-next',
                prevEl: '.js-popular-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                599: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                transitionEnd: function () {
                    bLazy.revalidate();
                }
            }
        }
    }
};

Event.on('Window.resized', function () {
    checkSliders(eshopSwipers);
});

$(function () {
    checkSliders(eshopSwipers);
});
